import Vue from 'vue'
import axios from 'axios'
import services from '@/utils/services'

export default {
  check() {
    let jwt = Vue.prototype.$session.get('jwt')
    let headers = {
      'Authorization': 'Bearer ' + jwt
    }
    return axios.get(services.routes.check, { headers })
      .then(response => {
        let res = response.data
        if (res.correcto) {
          return true
        } else {
          Vue.prototype.$session.destroy()
          return false
        }
      })
      .catch(error => {
        Vue.prototype.$session.destroy()
        return false
      })
  }
}
